import { Helmet } from 'react-helmet-async';
// sections
import Login from '../../../sections/auth/mediator/Login';

// ----------------------------------------------------------------------

export default function LoginPage() {
  return (
    <>
      <Helmet>
        <title>Accesso Mediatore | App di Mediazione Telefonica</title>
      </Helmet>

      <Login />
    </>
  );
}
